import environment from "./environment";
import endpoints from "./endpoints";

const raw = endpoints[environment];

const resolvedBaseUrl = process.env.REACT_APP_BASE_URL || raw.baseUrl;
let baseUrl = resolvedBaseUrl;

if (typeof window !== 'undefined' && resolvedBaseUrl) {
    try {
        const resolvedUrl = new URL(resolvedBaseUrl, window.location.href);
        if (resolvedUrl.origin === window.location.origin && raw.baseUrl) {
            baseUrl = raw.baseUrl;
        }
    } catch (error) {
        // If the override is not a valid URL we'll fall back to the raw base
        baseUrl = raw.baseUrl;
    }
}

const config = {
    environment,
    endpoints: {
        baseUrl,
        baseAdminUrl: process.env.REACT_APP_BASE_ADMIN_URL || raw.baseAdminUrl,
    },
};

export default config;
